import { useTranslation } from "react-i18next";
import globe from '@app/dashboard/assets/images/outerLayout/localization.png';
import { useLangStore } from "@app/dashboard/store/lang";
import styles from "./lang-switcher.module.scss";

const LangSwitcher = () => {

  const { t } = useTranslation();
  const { setLang } = useLangStore();

  return (
    <div className={styles['lang-switcher']} onClick={() => setLang()}>
      <img src={globe} alt="Localization" />
      <span>{t('outerLayout.language')}</span>
    </div>
  )
}

export default LangSwitcher;